import VueRouter from 'vue-router'
import Vue from 'vue'

import Public from './components/Public'
import Home from './components/Home'
//import CurrentSession from './components/CurrentSession'
import Auth from './components/Auth'
import ForgottenPassword from './components/ForgottenPassword'
import ExerciseList from './components/ExerciseList'
import HelloWorld from './components/HelloWorld'
import Sets from './components/Sets'
import Session from './components/Session'
import VideoSession from './components/VideoSession'
import Activity from './components/Activity'
import Schedule from './components/Schedule'
import DisplayScheduledSet from './components/DisplayScheduledSet'
import Welcome from './components/Welcome'
import Plans from './components/Plan'
import Support from './components/Support'
import Demo from './components/Demo'
import NewDemo from './components/NewDemo'
import NewSet from './components/NewSet'
import CheckVideos from './components/CheckVideos'
import VideoOverlay from './components/VideoOverlay'
import EndOfSession from './components/EndOfSession'
import EndOfDemoSession from './components/EndOfDemoSession'
import Layout from './components/Layout'
import ResponsiveTest from './components/ResponsiveTest'
import Responsive from './components/Responsive'
const routes = [
  { path: '/', component: Public },
  { path: '/auth', component: Auth },    
  { path: '/welcome', component: Welcome },    
  { path: '/plans', component: Plans },   
  { path: '/check', component: CheckVideos },  
  { path: '/overlay', component: VideoOverlay },  
  { path: '/endofsession', component: EndOfSession },    
  { path: '/endofdemosession', component: EndOfDemoSession }, 
  { path: '/home', component: Home  , meta: { requiresAuth: true}},
  { path: '/forgotten', component: ForgottenPassword },    
  // ExerciseList = the old NewSet component - no longer used - delete
  { path: '/list', component: ExerciseList , meta: { requiresAuth: true}},   
  { path: '/newset', component: NewSet , meta: { requiresAuth: true}},     
  { path: '/hello', component: HelloWorld },  
  { path: '/demo', component: Demo },    
  { path: '/newdemo', component: NewDemo },    
  { path: '/session', name: 'session', component: Session, meta: { requiresAuth: true}},
    { path: '/videosession', name: 'videosession', component: VideoSession, meta: { requiresAuth: true}},
  { path: '/sets', component: Sets, meta: { requiresAuth: true}},   
  { path: '/schedule', component: Schedule, meta: { requiresAuth: true}},       
  { path: '/setcountdown', component: DisplayScheduledSet, meta: { requiresAuth: true}},    
  { path: '/activity', component: Activity, meta: { requiresAuth: true}},   
  { path: '/support', component: Support, meta: { requiresAuth: true}},      
  { path: '/responsivetest', component: ResponsiveTest, meta: { requiresAuth: true}},        
  { path: '/responsive', component: Responsive, meta: { requiresAuth: true}},       
  { path: '/layout', component: Layout },   
  ]


const router = new VueRouter({
  //mode: 'history',
  routes
})



// 'to' is the destination object
// to.fullPath is the url + query params
// IF the user is not logged in and they have come to a specific page, we save it and the query params
// save it in the 'redirect' query param and we can reference it after successful login (Signin.vue) to redirect to
//
router.beforeResolve((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    //let user;
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
      if (data && data.signInUserSession) {
        //user = data;
        //console.log(user)

      } else {
        //console.log("User not authed......")
      }
    
      next()
    }).catch((e) => {
      console.log(e)

      localStorage.setItem("redirect", to.fullPath);
      next({
        path: '/auth',
        query: { redirect: to.fullPath }
      });
    });
  }

  next()})



export default router